import { render, staticRenderFns } from "./EntityCalculationViews.vue?vue&type=template&id=8975597a&scoped=true"
import script from "./EntityCalculationViews.vue?vue&type=script&lang=js"
export * from "./EntityCalculationViews.vue?vue&type=script&lang=js"
import style0 from "./EntityCalculationViews.vue?vue&type=style&index=0&id=8975597a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8975597a",
  null
  
)

export default component.exports